// extracted by mini-css-extract-plugin
export default {"main":"Gallery_main__24K3G","container":"Gallery_container__ZiSJQ","left":"Gallery_left__S84h8","background":"Gallery_background__NcNIM","right":"Gallery_right__2iCcp"};